/**
 * @file Builds the `NamedQueryRequest` a tab sends for one query at the
 * page's scope and period. Consumers: the tab panels, which start the query,
 * and the page shell, which reads the same answers by the same request.
 */
import type { NamedQueryId, NamedQueryRequest } from '#types';

import type { AnalyticsView } from './index.types';

export const analyticsRequest = (
  view: Pick<AnalyticsView, 'scope' | 'period'>,
  query: NamedQueryId,
): NamedQueryRequest => ({
  query,
  parameters: { period: view.period },
  level: view.scope,
});
